angular.module('impactx.MenuDirectives').controller('DeactivateRFQSSearchCtrl', [
    '$scope',
    'dataGen',
    '$context',
    'TranslationService',
    'RFQSearchService',
    'ToastService',
    '$redirect',
    '$location',
    '$securityManager',
    DeactivateRFQSSearchCtrl]);

function DeactivateRFQSSearchCtrl($scope, dataGen, $context, TranslationService, RFQSearchService, ToastService, $redirect, $location, $securityManager) {
    var self = this;
    self.showDeactivationButton = false;

    $scope.$watch(function() {
        return $context.hasRFQSSearch.value
    }, function(newValue) {
        self.showDeactivationButton = newValue;
        self.deactivateRFQSearchTranslation = TranslationService.get('deactivateRFQS');
    });

    self.deactivateRFQSearch = function() {
        RFQSearchService.deactivateRFQSSearchAndRedirect(true);
    };
}